module.exports = __webpack_public_path__ + "static/jwvansickle-4b80e2be13a9748065f22a0ac464ea0d.jpg";